import EcontextProcess from 'app/components/OrderPayment/Econtext/EcontextProcess';
import React from 'react';

const EcontextPayment = () => {
  return <EcontextProcess />;
};

export default EcontextPayment;
